import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { creditAPI } from "../../services/api";
import i18n from "../../i18n";

export const fetchCreditBalance = createAsyncThunk(
  "credits/fetchBalance",
  async (_, { rejectWithValue }) => {
    try {
      const response = await creditAPI.getBalance();
      return response.data;
    } catch (error) {
      return rejectWithValue(i18n.t("errors.fetchCreditBalanceFailed"));
    }
  }
);

const creditSlice = createSlice({
  name: "credits",
  initialState: {
    balance: 0,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCreditBalance.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCreditBalance.fulfilled, (state, action) => {
        state.loading = false;
        state.balance = action.payload.creditBalance;
      })
      .addCase(fetchCreditBalance.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default creditSlice.reducer;
